<template>
  <div class="outer-wrapper">
    <div class="title">
      <p>采购执行</p>
    </div>
    <Tabs>
      <TabPane label="待采购物品" icon="logo-buffer">
        <purchase-item-list
          :columnsFormatData="columnsFormatPurchase"
          askData="purchaseItemList"
          :refreshData="update_count"
          main_width="100%"
        ></purchase-item-list>
      </TabPane>
      <TabPane label="已采购物品" icon="logo-buffer">
        <purchase-item-list
          :columnsFormatData="columnsFormatPurchaseAlready"
          askData="purchaseItemListAlready"
          :refreshData="update_count"
          main_width="100%"
        ></purchase-item-list>
      </TabPane>
    </Tabs>
    <Modal v-model="modalValue.verify" :width="600" :mask-closable="false">
      <i class="ivu-icon ivu-icon-ios-close" slot="close" @click="closeModal('verify')"></i>
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>执行采购</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>实际采购数量({{newItem.pit}})：</td>
              <td>
                <input type="number" v-model="newItem.amount" min="1"/>
              </td>
            </tr>
            <tr>
              <td>总价格(元)：</td>
              <td>
                <input type="number" v-model="newItem.price" min="0"/>
              </td>
            </tr>
            <tr>
              <td>备注：</td>
              <td>
                <textarea type="text" placeholder v-model="newItem.remark"/>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="operation">提交</Button>
        <Button size="large" @click="closeModal('verify')">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import purchaseItemList from "@/components/Common/PurchaseItemList.vue";
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");
import dayjs from 'dayjs'
//import goodsExpand from "./goodsExpand.vue";


function newItemFac(){
  return {
    id:0,
    amount:1,
    price:0,
    result:"",
    remark:"",
  };
}


export default {
  name: "purchaseOperation",
  props: [],
  components: {
    purchaseItemList,
  },
  data() {
    return {
      update_count: 0,
      newItem:newItemFac(),
      modalValue: {
        verify: false,
      },
      resultList:[
        {text:'批准',value:"批准"},
        {text:'不批准',value:"不批准"},
      ],
      currentRecordDate:dayjs().format('YYYY-MM-DD'),
      spin:false,
      columnsFormatPurchase:[
        {
          title: "申购单号",
          key: "display_no",
          align: "center",
          width:150,
        },
        {
          title: "物品名称",
          key: "name",
          align: "center",
          width: 210,
          render: (h, p) => {
            let url = "/item/goods_c/" + p.row.goods_id.toString();
            return h(
              "span",
              {
                on: {
                    click: () => {
                      window.open(
                        url
                      );
                    }
                  },
                style:{
                  color:'#287dfd',
                  cursor:'pointer'
                }
              },
              p.row.name
            );
          }
        },
        {
          title: "类别",
          key: "catagory",
          width: 110,
          align: "center",
          render: (h, params) => {
            let text = this.revealCatagory(params.row.catagory);
            return h("div", [h("span", {}, text)]);
          }
        },
        {
          title: "子类别",
          key: "sub_catagory",
          width: 120,
          align: "center",
        },
        {
          title: "属性",
          key: "property",
          align: "center",
          minWidth: 300,
          render: (h, params) => {
            let text = this.revealProperty(params.row.property);
            return h("div", [h("span", {}, text)]);
          }
        },
        {
          title: "申请采购数量",
          key: "amount",
          width: 130,
          align: "center",
          sortable:true
        },
        {
          title: "当前库存",
          key: "goods_amount",
          width: 85,
          align: "center",
        },
        {
          title: "单位",
          key: "pit",
          width: 65,
          align: "center"
        },
        {
          title: "审核时间",
          key: "verify_time",
          align: "center",
          width:200,
        },
        {
          title: "申请备注",
          key: "remark",
          align: "center",
          width:150,
          tooltips:true
        },
        {
          title: "审核备注",
          key: "verify_remark",
          align: "center",
          width:150,
          tooltips:true
        },
        {
          title: "操作",
          align: "center",
          width: 130,
          fixed:'right',
          render: (h, params) => {
            return h("div", [
            // h(
            //     "Button",
            //     {
            //       props: {
            //         size: "small"
            //       },
            //       style: { color: "blue",marginRight:"5px" },
            //       on: {
            //         click: () => {
            //           window.open("/item/packageDetail/" + params.row.enid,"_blank");
            //         }
            //       }
            //     },
            //     "详情"
            //   ),
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "green" },
                  on: {
                    click: () => {
                      this.confirmOperation(params.row);
                    }
                  }
                },
                "采购"
              )
            ]);
          }
        }
        
      ],
      columnsFormatPurchaseAlready:[
        {
          title: "申购单号",
          key: "display_no",
          align: "center",
          width:150,
        },
        {
          title: "物品名称",
          key: "name",
          align: "center",
          width: 210,
          render: (h, p) => {
            let url = "/item/goods_c/" + p.row.goods_id.toString();
            return h(
              "span",
              {
                on: {
                    click: () => {
                      window.open(
                        url
                      );
                    }
                  },
                style:{
                  color:'#287dfd',
                  cursor:'pointer'
                }
              },
              p.row.name
            );
          }
        },
        {
          title: "类别",
          key: "catagory",
          width: 110,
          align: "center",
          render: (h, params) => {
            let text = this.revealCatagory(params.row.catagory);
            return h("div", [h("span", {}, text)]);
          }
        },
        {
          title: "子类别",
          key: "sub_catagory",
          width: 120,
          align: "center",
        },
        {
          title: "属性",
          key: "property",
          align: "center",
          minWidth: 300,
          render: (h, params) => {
            let text = this.revealProperty(params.row.property);
            return h("div", [h("span", {}, text)]);
          }
        },
        {
          title: "申请采购数量",
          key: "amount",
          width: 130,
          align: "center",
          sortable:true
        },
        {
          title: "实际采购数量",
          key: "purchase_amount",
          width: 130,
          align: "center",
          sortable:true
        },
        {
          title: "单位",
          key: "pit",
          width: 65,
          align: "center"
        },
        {
          title: "总价(元)",
          key: "price",
          width: 100,
          align: "center"
        },
        {
          title: "采购时间",
          key: "purchase_time",
          align: "center",
          width:200,
        },
        {
          title: "采购备注",
          key: "purchase_remark",
          align: "center",
          width:150,
          tooltips:true
        },
        {
          title: "采购人",
          key: "purchase_account",
          align: "center",
          width:150,
          tooltips:true
        },
        {
          title: "操作",
          align: "center",
          width: 130,
          fixed:'right',
          render: (h, params) => {
            return h("div", [
            // h(
            //     "Button",
            //     {
            //       props: {
            //         size: "small"
            //       },
            //       style: { color: "blue",marginRight:"5px" },
            //       on: {
            //         click: () => {
            //           window.open("/item/packageDetail/" + params.row.enid,"_blank");
            //         }
            //       }
            //     },
            //     "详情"
            //   ),
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "green" },
                  on: {
                    click: () => {
                      this.confirmCancel(params.row);
                    }
                  }
                },
                "撤销"
              )
            ]);
          }
        }
        
      ],
    };
  },
  created() {
  },
  methods: {
    confirmOperation(value) {
      this.newItem.id = value.id;
      this.newItem.pit = value.pit;
      this.modalValue.verify = true;
    },
    operation() {
      this.$axios
        .post(this.$url + "/purchase", {
          userToken: userToken,
          askData: "purchaseItem",
          id: this.newItem.id,
          price:this.newItem.price,
          amount:this.newItem.amount,
          remark:this.newItem.remark,
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.$Message.success("审核成功！");
            this.modalValue.verify = false;
            this.update_count++;
            this.newItem = newItemFac();
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    confirmCancel(row) {
      this.$axios
        .post(this.$url + "/purchase", {
          userToken: userToken,
          askData: "purchaseCancel",
          id: row.id,
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.$Message.success("撤销成功！");
            this.modalValue.verify = false;
            this.update_count++;
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    linkTo(url) {
      window.open(this.$fileUrlFac(url, authData.sfileRight));
    },
    openModal(value) {
      this.modalValue[value] = true;
    },
    closeModal(value) {
      this.modalValue[value] = false;
    },

    revealProperty(value) {
      let tmp;
      if (typeof value === "string" && value.length > 0) {
        tmp = JSON.parse(value);
      } else {
        tmp = {};
      }
      let text = "";
      if (tmp.spec) {
        text += "规格:" + tmp.spec + ";";
      }
      if (tmp.model) {
        text += "型号:" + tmp.model + ";";
      }
      if (tmp.mat) {
        text += "材质:" + tmp.mat + ";";
      }
      if (tmp.volume) {
        text += "容积:" + tmp.volume + ";";
      }
      if (tmp.brand) {
        text += "品牌:" + tmp.brand + ";";
      }
      if (tmp.seller) {
        text += "供货商:" + tmp.seller + ";";
      }
      if (tmp.diameter) {
        text += "外径:" + tmp.diameter + ";";
      }
      if (tmp.bore) {
        text += "内径:" + tmp.bore + ";";
      }
      if (tmp.thickness) {
        text += "壁厚:" + tmp.thickness + ";";
      }
      if (tmp.pressure) {
        text += "压力:" + tmp.pressure + ";";
      }
      if (tmp.standard) {
        text += "标准:" + tmp.standard + ";";
      }
      if (tmp.grade) {
        text += "级别:" + tmp.grade + ";";
      }
      if (tmp.other) {
        text += "其他:" + tmp.other + ";";
      }
      return text;
    },
  },
};
</script>
<style scoped>
.outer-wrapper {
  width: 98%;
  min-width: 1280px;
  margin: 0 auto;
}
.title {
  text-align: center;
  margin: 10px auto;
  font-size: 20px;
}

.sc-content-wrapper{
  width:100%;
}

.inner-content-wrapper{
  width:100%;
}

.cr-form {
  width: 100%;
  border-collapse: collapse;
}

.cr-form td {
  height: 45px;
}

.cr-form td:first-child {
  width:30%;
  text-align: right;
}

.cr-form input,
.cr-form select {
  padding: 0 10px;
  outline: none;
  height: 30px;
  border-radius: 2px;
  border: 1px solid #aaa;
  width:200px;
}

textarea {
  padding: 5px;
  width:80%;
}

</style>